module.exports = __webpack_public_path__ + "portrait.jpg?6dfd2e93fcff01d811035ad045353c0c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portrait.jpg
// module id = 67
// module chunks = 0